import { getStoreShippingAddrs } from '@/api/refer-modal';
import { deepCopy } from '@/u-components/utils/assist';
const returnStoreActionRefer = (ctrl, vm, data) => {
  const tableHeader = [
    {
      showCaption: vm.mlang('receiveStoreName'),
      fieldName: 'name',
      isShowIt: true,
      width: 120
    },
    {
      showCaption: vm.mlang('storeAddress'),
      fieldName: 'custShippingAddress_cAddress',
      isShowIt: true,
      render: (h, params) => {
        let { row, column } = params;
        let data = row[column.key];
        return <span title={data} class={'two-line-overflow-hide'}>{data}</span>;
      }
    },
    {
      showCaption: vm.mlang('storeCode'),
      isShowIt: true,
      fieldName: 'code',
      width: 100
    }
  ];
  const conditions = [];
  let agentInfo = {
    conditionType: 'eq',
    name: 'agentId',
    v1: vm.$store.getters.currentUser.agentId,
    valueType: 'LONG'
  };
  if (!vm.$store.getters.currentUser.userType) {
    conditions.push({
      name: 'userId',
      v1: vm.$store.getters.currentUser.userId,
      valueType: 'LONG',
      conditionType: 'eq'
    });
  }
  conditions.push(agentInfo);
  const control = Object.assign(
    {},
    {
      page: true,
      bRefer: true,
      bread: false,
      multiple: false,
      controlType: 'Refer',
      refReturnValue: 'returnStore',
      hideQueryschema: true,
      refName: 'returnStoreName',
      // 传递过去的参数
      passedparams: conditions,
      queryschema: [

      ],
      columns: tableHeader,
      actions: { queryList: getStoreShippingAddrs },
      type: 'string',
      op: 'eq'
    },
    ctrl
  );
  return deepCopy(control);
};
export default returnStoreActionRefer;
